import "@/App.css";
import { BrowserRouter, Routes, Route, Outlet, Navigate } from "react-router-dom";
import { AppShell } from "@/components/AppShell";
import { AuthProvider, useAuth } from "@/lib/auth";
import DashboardPage from "@/pages/Dashboard";
import ContactsPage from "@/pages/Contacts";
import ContactDetailPage from "@/pages/ContactDetail";
import CompaniesPage from "@/pages/Companies";
import ProspectPage from "@/pages/Prospect";
import CleanupPage from "@/pages/Cleanup";
import ListsPage from "@/pages/Lists";
import ListDetailPage from "@/pages/ListDetail";
import SegmentsPage from "@/pages/Segments";
import TemplatesPage from "@/pages/Templates";
import CampaignsPage from "@/pages/Campaigns";
import CampaignDetailPage from "@/pages/CampaignDetail";
import FolderReportPage from "@/pages/FolderReport";
import AnalyticsPage from "@/pages/Analytics";
import SenderHealthPage from "@/pages/SenderHealth";
import SequencesPage from "@/pages/Sequences";
import CampaignComparePage from "@/pages/CampaignCompare";
import PreferenceCentrePage from "@/pages/PreferenceCentre";
import SuppressionsPage from "@/pages/Suppressions";
import SettingsPage from "@/pages/Settings";
import GuidePage from "@/pages/Guide";
import PublicationsPage from "@/pages/Publications";
import PublicGatePage from "@/pages/PublicGate";
import LoginPage from "@/pages/Login";
import AcceptInvitePage from "@/pages/AcceptInvite";
import { Toaster } from "sonner";

const RequireAuth = () => {
  const { user } = useAuth();
  if (user === undefined) {
    return <div className="min-h-screen flex items-center justify-center text-sm text-zinc-400" data-testid="auth-loading">Loading…</div>;
  }
  if (!user) return <Navigate to="/login" replace />;
  return <AppShell><Outlet /></AppShell>;
};

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/invite/:token" element={<AcceptInvitePage />} />
          <Route path="/p/:pid" element={<PublicGatePage />} />
          <Route path="/preferences/:contactId" element={<PreferenceCentrePage />} />
          <Route element={<RequireAuth />}>
            <Route path="/" element={<DashboardPage />} />
            <Route path="/contacts" element={<ContactsPage />} />
            <Route path="/contacts/:id" element={<ContactDetailPage />} />
            <Route path="/companies" element={<CompaniesPage />} />
            <Route path="/prospect" element={<ProspectPage />} />
            <Route path="/cleanup" element={<CleanupPage />} />
            <Route path="/lists" element={<ListsPage />} />
            <Route path="/lists/:id" element={<ListDetailPage />} />
            <Route path="/segments" element={<SegmentsPage />} />
            <Route path="/templates" element={<TemplatesPage />} />
            <Route path="/campaigns" element={<CampaignsPage />} />
            <Route path="/campaigns/folder/:gid" element={<FolderReportPage />} />
            <Route path="/campaigns/:id" element={<CampaignDetailPage />} />
            <Route path="/publications" element={<PublicationsPage />} />
            <Route path="/analytics" element={<AnalyticsPage />} />
            <Route path="/analytics/compare" element={<CampaignComparePage />} />
            <Route path="/health" element={<SenderHealthPage />} />
            <Route path="/sequences" element={<SequencesPage />} />
            <Route path="/suppressions" element={<SuppressionsPage />} />
            <Route path="/settings" element={<SettingsPage />} />
            <Route path="/guide" element={<GuidePage />} />
          </Route>
        </Routes>
      </AuthProvider>
      <Toaster position="top-right" richColors />
    </BrowserRouter>
  );
}

export default App;
